import { Component } from '@angular/core';

@Component({
  selector: 'app-three-dots-blinking-vertical',
  templateUrl: './three-dots-blinking-vertical.component.html',
  styleUrls: ['./three-dots-blinking-vertical.component.scss'],
  standalone: false
})
export class ThreeDotsBlinkingVerticalComponent {

}
